import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdminService } from '../../../_services/admin/admin.service';
import { ResponseItem } from '../../../_models/item-info/response.item';
import { TypeaheadItem } from '../../../_models/typeahead/typeahead.item';

@Component({
  selector: 'app-admin-item-input',
  templateUrl: './admin-item-input.component.html',
  styleUrls: ['./admin-item-input.component.scss']
})
export class AdminItemInputComponent implements OnInit {
  @Input() label: string;
  @Input() centerLabel: boolean;
  @Input() model: number;
  @Output() modelChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() modelObject: ResponseItem;
  @Output() modelObjectChange: EventEmitter<ResponseItem> = new EventEmitter<ResponseItem>();
  @Output() inputClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() labelCols: number;
  @Input() dividerKind: number;
  @Input() focusInput: EventEmitter<boolean>;
  @Input() noneSelectionLabel: string;
  @Input() noneSelectionModelValue: number;
  @Input() stopSearchingOnBlur: boolean;
  @Input() noneSelectedText: string;
  searching: boolean;
  @Output() onFocusInput = new EventEmitter<boolean>();
  @Output() onBlurInput = new EventEmitter<boolean>();
  
  constructor(
    public adminService: AdminService
  ) { }

  ngOnInit(): void {
    if (!this.focusInput) { this.focusInput = new EventEmitter<boolean>(); }
    if (this.noneSelectionLabel && !this.noneSelectionModelValue) { this.noneSelectionModelValue = 0; }
    if (this.noneSelectionLabel && this.stopSearchingOnBlur === undefined) { this.stopSearchingOnBlur = true; }
    if (this.noneSelectionLabel) { this.searching = this.model !== this.noneSelectionModelValue; }
    if (this.model !== this.noneSelectionModelValue) {
      this.getObjectModel(this.model);
    }
    if (this.model === 0 && !this.noneSelectionLabel) { this.doSearch(); }
  }

  clickModel(event: MouseEvent) {
    this.inputClick.emit(event);
  }

  getObjectModel(model: number) {
    if (model) {
      this.adminService.getItemNumber(this.adminService.currentUid.Wholesaler, model)
        .subscribe(result => {
          if (result) {
            if (this.model !== result.InternalItemNumber) {
              this.model = result.InternalItemNumber;
              this.modelChange.emit(this.model);
            }
            if (!this.modelObject || this.modelObject.InternalItemNumber !== result.InternalItemNumber) {
              this.modelObject = result;
              this.modelObjectChange.emit(this.modelObject);
            }
          }
          this.searching = false;
        });
    }
  }

  objectChange(value: TypeaheadItem) {
    if (value.InternalItemNumber !== this.model) { this.getObjectModel(value.InternalItemNumber); }
  }

  doSearch(): void {
    this.searching = true;
    setTimeout(() => {
      this.focusInput.emit(true);
    }, 0);
  }

  clear(event: MouseEvent) {
    if (!this.disabled) {
      this.model = this.noneSelectionModelValue;
      this.modelObject = null;
      this.modelChange.emit(this.model);
      this.modelObjectChange.emit(this.modelObject);
    }
    event.stopPropagation();
  }

  typeaheadBlur(event: any) {
    if (this.stopSearchingOnBlur) {
      setTimeout(() => this.searching = false, 50);
    }
  }

  

}
